import { makeAction, makeReducer } from '@finn-no/redux-actions';

import type { Hotel } from '../interfaces';
import defaultState from './defaultState';

export const actions = {
    setHotel: makeAction<Hotel>('HOTEL', (_, action) => ({ ...defaultState.hotel, ...action.payload })),
};

export default actions;
export const hotelReducer = makeReducer<Hotel>(actions);
